export { AppletFrame, type AppletFrameProps } from './appletFrame';
